import { TechnicalData } from '@/types/vehicle'
import styles from './dimensions.module.scss'
import { formatWithCommas } from '@/lib/utilities/search'
import { FILTER_VEHICLE_TYPES_VANS } from '@/lib/constants'

export type DimensionsProps = {
  activeImage: string
  technicalData: TechnicalData
  vehicleType: number
}

export const Dimensions = ({ activeImage, technicalData, vehicleType }: DimensionsProps) => {

    const sizeDataPoints = [
      {
        metric: 'mm',
        value:
          technicalData[4]?.displayValue !== 'N'
            ? formatWithCommas(Number(technicalData[4]?.displayValue))
            : '---',
        label: 'Length',
      },
      {
        metric: 'mm',
        value:
          technicalData[5]?.displayValue && technicalData[5]?.displayValue !== 'N'
            ? formatWithCommas(Number(technicalData[5]?.displayValue))
            : technicalData[33]?.displayValue && technicalData[33]?.displayValue !== 'N'
              ? formatWithCommas(Number(technicalData[33].displayValue))
              : '---',
        label: 'Width',
      },
      {
        metric: 'mm',
        value:
          technicalData[15]?.displayValue && technicalData[15]?.displayValue !== 'N'
            ? formatWithCommas(Number(technicalData[15]?.displayValue))
            : '---',
        label: 'Wheelbase',
      },
      {
        metric: 'mm',
        value:
          technicalData[34]?.displayValue && technicalData[34]?.displayValue !== 'N'
            ? formatWithCommas(Number(technicalData[34]?.displayValue))
            : technicalData[35]?.displayValue && technicalData[35]?.displayValue !== 'N'
              ? formatWithCommas(Number(technicalData[35].displayValue))
              : '---',
        label: 'Height',
      },
    ]

  return (
    <>
      {activeImage === 'sideview' && (
        <>
          {vehicleType === FILTER_VEHICLE_TYPES_VANS && (
            <div className={`${styles.dimensions} ${styles.wheelbase}`}>
              <span>{sizeDataPoints.filter(item => item.label === 'Wheelbase')[0].value}mm</span>
            </div>
          )}
          <div className={`${styles.dimensions} ${styles.length} ${vehicleType === FILTER_VEHICLE_TYPES_VANS ? styles['with-wheelbase'] : ''}`}>
            <span>{sizeDataPoints.filter(item => item.label === 'Length')[0].value}mm</span>
          </div>
        </>
      )}
      <div className={`${styles.dimensions} ${styles.height}`}>
        <span>{sizeDataPoints.filter(item => item.label === 'Height')[0].value}mm</span>
      </div>
      {activeImage !== 'sideview' && (
        <div className={`${styles.dimensions} ${styles.width}`}>
          <span>{sizeDataPoints.filter(item => item.label === 'Width')[0].value}mm</span>
        </div>
      )}
    </>
  )
}
